module.exports = __webpack_public_path__ + "static/media/markerStart.0f99e572.svg";